import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/ComoEmagrecerMorandoAustralia";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/como-emagrecer-morando-na-australia")({
  head: () =>
    pageHead({
      title: "Como emagrecer morando na Austrália | Guia prático | Clara Camille",
      description:
        "Guia prático e realista para emagrecer morando na Austrália. Sem dieta restritiva, com produtos locais e acompanhamento em português. Consulta inicial gratuita.",
      path: "/como-emagrecer-morando-na-australia",
      jsonLd: [
        faqJsonLd(faqItems),
        breadcrumbJsonLd([
          { name: "Como emagrecer morando na Austrália", path: "/como-emagrecer-morando-na-australia" },
        ]),
      ],
    }),
  component: Page,
});
